module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      backgroundColor: _vm.background
    }),
    attrs: {
      "id": "app-footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 news"
  }, [_c('h3', [_vm._v("Newsletter")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt.")]), _vm._v(" "), _c('p', [_vm._v("Sed do eiusmod tempor incididunt.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.verifyEmail()
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "you@email.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-sm-6 about"
  }, [_c('h3', [_vm._v("About")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.")]), _vm._v(" "), _c('p', [_vm._v("Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut.")]), _vm._v(" "), _c('p', [_vm._v("Consectetur adipisicing elit.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-sm-6 contact"
  }, [_c('h3', [_vm._v("Contact")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor.")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('p', [_vm._v("Topanga Canyon")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('p', [_vm._v("office@crs-consulting")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-phone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('p', [_vm._v("(800) 888-8888")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-sm-6 latest"
  }, [_c('h3', [_vm._v("Latest News")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit."), _c('br'), _c('span', [_vm._v("1 hour ago")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit."), _c('br'), _c('span', [_vm._v("1 hour ago")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Signup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright"
  }, [_c('span', [_vm._v("© Copyright. All Rights Reserved CRS-Consulting 2016 - 2017")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2086da38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
// module id = 77
// module chunks = 0